import Page from 'v5/auth/RequestPasswordResetPageRelay.bs'
import { requireUnauthenticated } from '../../hoc/AuthenticatedComponent'
import { asLayout as loginLayout } from '../../modules/Login/LoginLayout.bs'
import { withMainLayout } from '../../pagesComponents/MainApp'
import { compose } from 'ramda'

const RequestPasswordResetPage = requireUnauthenticated(Page)

RequestPasswordResetPage.getLayout = compose(withMainLayout, loginLayout)

export default RequestPasswordResetPage
